import styled from 'styled-components';
import constants from '../../../abstracts/constants';
import colours from '../../../abstracts/colours';

interface LinkProps {
  selected?: boolean;
  disabled?: boolean;
  disableVisited?: boolean;
  size?: string;
}

export const LinkContainer = styled.span<LinkProps>`
  * {
    font-size: ${({ size }) => size || constants.LARGE};
    font-family: ${constants.sourceSansPro};
    color: ${({ selected, disabled }) =>
      disabled ? colours.doveGray : selected ? colours.black : colours.scienceBlue};
    pointer-events: ${({ selected, disabled }) => (selected || disabled ? 'none' : 'auto')};
    text-decoration: ${({ selected }) => (selected ? 'none' : 'underline')};
    &:visited {
      color: ${({ disabled, disableVisited, selected }) =>
        disabled ? colours.doveGray : selected ? colours.black : disableVisited ? colours.scienceBlue : colours.cobalt};
    }
    &:focus {
      background-color: ${({ selected }) => (selected ? 'none' : `${colours.scienceBlue}0F`)};
    }
    &:hover {
      color: ${colours.bluish};
    }
    &:active {
      color: ${colours.cobalt};
    }
  }
`;
